import { Box, Typography } from '@mui/material';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';

export const EmptyState = ({ message = 'No data found.' }) => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={8} color="text.secondary">
    <InboxRoundedIcon sx={{ fontSize: 52, mb: 2, opacity: 0.25 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);
